import {put} from "redux-saga/effects";
import type {SagaMount} from "../state/types";

export function *saga () {

    yield put<SagaMount>({
        type: "SagaMount"
    });
}